// console.log('o', process.env.VUE_APP_AGENT_ID, process.env.VUE_APP_CORP_ID)
const config = {
    // 在 https://work.weixin.qq.com/wework_admin/frame#profile 这里可以找到
    // //美耀
    // corpId: 'wwa05c800520295d34',
    // agentId: '1000007'
    // 中医诊所
    corpId: 'ww818378c3fb8a0213',
    agentId: '1000002'
    // // 中医诊所2
    // corpId: 'ww72937180e2a8591e',
    // agentId: '1000005'
};
export default config;
